import { render, staticRenderFns } from "./CreateBasicAccount.vue?vue&type=template&id=216ba56c&"
import script from "./CreateBasicAccount.vue?vue&type=script&lang=js&"
export * from "./CreateBasicAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports